import React from 'react';
import { Card } from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
// import { Card, CardBody, CardText, CardTitle } from 'react-bootstrap';
import './Supports.css';

import supptouchlcmbg from '../images/PageImg/SupportTouchLcm-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'
import { SuppTouchLcm10 } from "../assets/SupportsData";
import { SuppTouchLcm12 } from "../assets/SupportsData";
import { SuppTouchLcm15 } from "../assets/SupportsData";
import { SuppTouchLcm18 } from "../assets/SupportsData";
import { SuppTouchLcm21 } from "../assets/SupportsData";

import SuppTouchLcm101Img from '../images/SupportImg/SuppTouchLcm101.jpg';
import SuppTouchLcm123Img from '../images/SupportImg/SuppTouchLcm123.jpg';
import SuppTouchLcm156Img from '../images/SupportImg/SuppTouchLcm156.jpg';
import SuppTouchLcm185Img from '../images/SupportImg/SuppTouchLcm185.jpg';
import SuppTouchLcm215Img from '../images/SupportImg/SuppTouchLcm215.jpg';

import { GoTopBtn } from '../components/GoTopBtn';

function SuportTouchLcm() {
  // console.log("get into SuppTouchLcm()");
  return (
    /* Support / Touch Display Catelogy */
    <div className='support-page'>
      <div className='supportheader'
        style={{ backgroundImage: `url(${supptouchlcmbg})`, height: "auto" }} >
        <HeaderSlide text={'Support / Touch Display'} />
        <h4 className='text-light'>&nbsp;images/PageImg/SupportTouchLcm-page-bg.jpg</h4>
      </div>

      {/* Support / Touch LCM 10 inch */}
      <section id='supptouchlcm10' className='supptouchlcm bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support / Touch LCM 10 inch</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppTouchLcm101Img} className='mt-5 mt-lg-0' alt="" />
              <h5>images/SupportImg/SuppTouchLcm101Img.jpg</h5>
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-evenly'> {
              SuppTouchLcm10.map((touchlcm) => (
                <Row key={touchlcm.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-primary px-3 my-1'> {touchlcm.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingTouchLCMBySize/${touchlcm.size}`} className='btn suppbtn-success'> {touchlcm.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
          </Row>
        </Container>
      </section>

      {/* Support / Touch LCM 12 inch */}
      <section id='supptouchlcm12' className='supptouchlcm bg-primary-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-success'>Support / Touch LCM 12 inch</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppTouchLcm12.map((touchlcm) => (
                <Row key={touchlcm.id}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-success px-3 my-1'> {touchlcm.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingTouchLCMBySize/${touchlcm.size}`} className='btn suppbtn-primary'> {touchlcm.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppTouchLcm123Img} className='mt-5 mt-lg-0' alt="" />
              <h5>images/SupportImg/SuppTouchLcm123Img.jpg</h5>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Support / Touch LCM 15 inch */}
      <section id='supptouchlcm15' className='supptouchlcm bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support / Touch LCM 15 inch</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppTouchLcm156Img} className='mt-5 mt-lg-0' alt="" />
              <h5>images/SupportImg/SuppTouchLcm156Img.jpg</h5>
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppTouchLcm15.map((touchlcm) => (
                <Row key={touchlcm.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-primary px-3 my-1'> {touchlcm.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingTouchLCMBySize/${touchlcm.size}`} className='btn suppbtn-success'> {touchlcm.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
          </Row>
        </Container>
      </section>

      {/* Support / Touch LCM 18 inch */}
      <section id='supptouchlcm18' className='supptouchlcm bg-primary-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-success'>Support / Touch LCM 18 inch</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppTouchLcm18.map((touchlcm) => (
                <Row key={touchlcm.id}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-success px-3 my-1'> {touchlcm.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingTouchLCMBySize/${touchlcm.size}`} className='btn suppbtn-primary'> {touchlcm.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppTouchLcm185Img} className='mt-5 mt-lg-0' alt="" />
              <h5>images/SupportImg/SuppTouchLcm185Img.jpg</h5>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Support / Touch LCM 21 inch */}
      <section id='supptouchlcm21' className='supptouchlcm bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support / Touch LCM 21 inch</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppTouchLcm215Img} className='mt-5 mt-lg-0' alt="" />
              <h5>images/SupportImg/SuppTouchLcm215Img.jpg</h5>
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppTouchLcm21.map((touchlcm) => (
                <Row key={touchlcm.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-primary px-3 my-1'> {touchlcm.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingTouchLCMBySize/${touchlcm.size}`} className='btn suppbtn-success'> {touchlcm.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
          </Row>
        </Container>
      </section>

      <div> < GoTopBtn /> </div>
    </div>
  )
}

export default SuportTouchLcm;

/*
<br /> <br /> <br />
<header className='mt-5'>
  <Container className='h-100 d-flex align-items-center justify-content-center'>
    <h1 className='text-light'>Support / Touch LCM</h1>
  </Container>
</header>
*/
/*
<Row>
  <Col lg={6} className='d-flex flex-column justify-content-center'>
    <img src={SuppTouchLcm101Img} className='mt-5 mt-lg-0' alt="" />
    // <img src={SuppTouchLcm101Img} className='w-80' style={{ height: '50vh' }} alt="" />
    // <img src={SuppTouchLcm123Img} className='mt-4' style={{ height: '60vh' }} alt="" />
    // <img src={SuppTouchLcm156Img} className='mt-5' style={{ height: '80vh' }} alt="" />
    // <img src={SuppTouchLcm185Img} className='mt-5 mt-lg-0' style={{ height: '60vh' }} alt="" />
    // <img src={SuppTouchLcm215Img} className='mt-5 mt-lg-0' style={{ height: '60vh' }} alt="" />
  </Col>
  <Col lg={6} className='d-flex flex-column justify-content-evenly'> {
    SuppTouchLcm10.map((touchlcm) => (
      <Row key={touchlcm.id}>
        <Card className='bg-info-subtle border-1 p-0 m-0'>
          <Card.Body className='d-flex justify-content-center'>
            <Card.Title className='fs-2 text-primary px-3 my-1'> {touchlcm.name} </Card.Title>
            // <Card.Title className='fs-2 text-primary px-3 my-1'> {touchlcm.name} </Card.Title>
            <Card.Text className='fs-4'>
              // <Card.Text className='fs-4'>
              <a href={`/ListingTouchLCMBySize/${touchlcm.size}`} className='btn suppbtn-success'> {touchlcm.text} </a>
            </Card.Text>
          </Card.Body>
        </Card>
      </Row>
  } </Col>
</Row>
*/
